const isDevelopEnvironment = process.env.REACT_APP_ENVIRONMENT !== 'production';

export const resideoProLink = isDevelopEnvironment
  ? 'https://develop--resideo-pro.netlify.app'
  : `${window.location.origin}`;

export const resideoLink = 'https://www.resideo.com';
export const resideoUsEnLink = `${resideoLink}/us/en`;
export const resideoHomeLink = `${resideoUsEnLink}/pro`;

export const resideoProductsAirLink = `${resideoHomeLink}/products/air/`;
export const resideoSolutionsLink = `${resideoHomeLink}/solutions/`;
export const resideoResourcesLink = `${resideoHomeLink}/resources/`;
export const resideoPerksLink = `${resideoHomeLink}/resideo-pro-perks/`;

export const resideoProProfileLink = `${resideoProLink}/profile`;
export const resideoProAircycleLink = `${resideoProLink}/aircycle`;
export const resideoProPerksLink = `${resideoProLink}/perks`;
export const resideoProCompanyApplicationLink = `${resideoProLink}/company/application`;
export const resideoProMybusinessLink = `${resideoProLink}/mybusiness`;
export const resideoProMybusinessCompanyLink = `${resideoProLink}/mybusiness/company`;
export const resideoProMybusinessDashboardLink = `${resideoProLink}/mybusiness/dashboard`;
export const resideoProMybusinessCustomersLink = `${resideoProLink}/mybusiness/customers`;
export const resideoProHomeownerAppBrandingCompleteSetupLink = `${resideoProLink}/mybusiness/co-branding/logo`;
export const resideoProHomeownerAppBrandingDashboardLink = `${resideoProLink}/mybusiness/co-branding/dashboard`;
